// src/shared/services/navigationService.js
let navigateFn = null;

export const setNavigate = (navigate) => {
  navigateFn = navigate;
};

export const navigateTo = (path) => {
  if (navigateFn) {
    navigateFn(path);
  } else {
    console.error('navigate function not set yet');
  }
};
